import React, { useState } from "react";
import './QuestionBox.css'
import Button from "./Button";
import TextArea from "./TextArea";

function QuestionBox({ onQuestionTextChanged, onSubmitQuestion, isEnabled }) {
    return (
        <div className="question-box">
            <TextArea
                placeholder={"Message to the assistant"}
                onTextChanged={onQuestionTextChanged}
            />
            { isEnabled &&
                <Button
                    text={"Send"}
                    onClick={onSubmitQuestion}
                />
            }
        </div>
    );
}

export default QuestionBox

